import React from "react";
import SubmitButton from "../../../components/button/SubmitButton";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import { findObjectKeyByValue } from "../../../utils/helper";
import { GENDER, SNACK_BAR_VARIETNS } from "../../../utils/constants";
import moment from "moment";
import OscillaLauncher from "./Oscilla";
import AudioGram from "../AudioGram";
import OneViewBox from "../../../components/layouts/OneViewBox";
import { center } from "../../../assets/css/theme/common";
import { callApiAction } from "../../../store/actions/commonAction";
import { getSendMessageApi } from "../../../apis/oscilla.api";
import { callSnackBar } from "../../../store/actions/snackbarAction";
import { useDispatch, useSelector } from "react-redux";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { Navigate, useNavigate } from "react-router-dom";
import OtoScopDataUi from "../OtoScopeUi";
// import SuggestedDevices from '../SuggestedDeviced'
import CloseIcon from "@mui/icons-material/Close";

import ReactDOM from "react-dom";
import { startOscillaLoadingValues } from "../../../store/actions/OscillaDataAction";
import AudiogramReport from "./AudiogramReport";
const BeneficiaryAudioGramUI = ({
  updateFunction,
  onValidate,
  updated_by,
  fields,
  setFields,
  _id,
  setOscillaAudiogramState,
  loading,
  setLoading,
  step,
  setStep,
  oscillaAudiogramState,
  fetchById,
  setBackStep,
  loadAudiogram,
  setFieldsdata,
}) => {
  const [msgLoading, setMsgLoading] = React.useState(false);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state);

  const SendMessage = () => {
    setMsgLoading(true);
    dispatch(
      callApiAction(
        async () =>
          await getSendMessageApi({
            id: fields?._id,
            phonenumber: fields?.phone,
          }),
        (response) => {
          setMsgLoading(false);
          dispatch(
            callSnackBar(
              "Report Sent Successfully",
              SNACK_BAR_VARIETNS.suceess,
            ),
          );
        },
        (err) => {
          setMsgLoading(false);
          dispatch(
            callSnackBar("Failed to send report", SNACK_BAR_VARIETNS.error),
          );
        },
      ),
    );
  };
  const navigate = useNavigate();
  return (
    <>
      {loading &&
        ReactDOM.createPortal(
          <Backdrop
            open={loading}
            sx={{
              zIndex: 99999,
              color: "#fff",
              backgroundColor: "rgba(255,255,255,0.65)",
              backdropFilter: "blur(2px)",
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={() => {
                dispatch(startOscillaLoadingValues(false));
              }}
              sx={{
                position: "fixed",
                top: 16,
                right: 16,
                zIndex: 100000,
                width: 48,
                height: 48,
                backgroundColor: "#fff",
                color: "#666",
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <CloseIcon />
            </IconButton>

            {/* Loader */}
            <Box
              onClick={(e) => e.stopPropagation()}
              sx={{ pointerEvents: "none" }}
            >
              <CircularProgress size={50} />
            </Box>
          </Backdrop>,
          document.body,
        )}
      {step === 0 && (
        <>
          <IconButton
            fullWidth
            color="info"
            disableElevation
            size="inherit"
            onClick={() => { setBackStep(0); setFieldsdata({ ...fields }); }}
          >
            <KeyboardArrowLeftIcon /> <Typography>BACK</Typography>
          </IconButton>
          {
            <OtoScopDataUi
              fields={fields}
              setFields={setFields}
              fetchFunction={fetchById}
            />
          }

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box mt={2}>
              <SubmitButton
                onClick={() => {
                  setStep(step + 1);
                }}
                type="button"
                sx={{ maxWidth: "200px" }}
                title={step == 1 ? "Submit" : "Next" + ``}
              />
            </Box>
          </Box>
        </>
      )}

      {step === 1 && (
        <Paper sx={{ p: 3 }}>
          <IconButton
            fullWidth
            color="info"
            disableElevation
            size="inherit"
            onClick={() =>
              step === 0
                ? navigate("/beneficiary/beneficiary-data")
                : setStep(step - 1)
            }
          >
            <KeyboardArrowLeftIcon /> <Typography>BACK</Typography>
          </IconButton>
          {
            <>
              <AudioGram
                fields={fields}
                setFields={setFields}
                setOscillaAudiogramState={setOscillaAudiogramState}
                oscillaAudiogramState={oscillaAudiogramState}
              />
              <Box sx={{ display: "flex", width: "100%", mt: 2 }}>
                {
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      width: "100%",
                      gap: 2,
                    }}
                  >
                    <Button
                      disabled={msgLoading}
                      onClick={SendMessage}
                      variant="contained"
                      color="primary"
                      sx={{ height: "5vh" }}
                    >
                      Send Report
                    </Button>
                  </Box>
                }
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 2,
                    width: "100%",
                  }}
                >
                  <SubmitButton
                    variants="outlined"
                    type="button"
                    onClick={() => {
                      loadAudiogram();
                    }}
                    sx={{ width: "15vw" }}
                    title={"LOAD AUDIOGRAM"}
                  />
                  <OscillaLauncher
                    wehearId={fields?._id}
                    updated_by={user?.data?._id}
                    patientId={_id}
                    firstName={fields?.first_name}
                    lastName={fields?.last_name}
                    org={user?.data?._id}
                    birthDate={
                      moment(fields?.dob).format("YYYYMMDD") || "20021130"
                    }
                    gender={findObjectKeyByValue(
                      Number(fields?.gender),
                      GENDER,
                    )}
                  />
                  <SubmitButton
                    disabled={!oscillaAudiogramState.allowed_Oscilla}
                    // variants="outlined"
                    type="button"
                    onClick={() => {
                      setStep(step + 1);
                    }}
                    sx={{ width: "15vw" }}
                    title={step == 2 ? "Submit" : "Next" + ``}
                  />
                </Box>
              </Box>
            </>
          }
        </Paper>
      )}

      {step === 2 && (
        <>
          {" "}
          <Paper
            sx={{ p: 3 }}
            display="flex"
            flexDirection="column"
            height="100%"
            gap={10}
          >
            <IconButton
              fullWidth
              color="info"
              disableElevation
              size="inherit"
              onClick={() =>
                step === 0
                  ? navigate("/beneficiary/beneficiary-data")
                  : setStep(step - 1)
              }
            >
              <KeyboardArrowLeftIcon /> <Typography>BACK</Typography>
            </IconButton>
            <Box mb={3}>
              <AudiogramReport id={fields?._id || _id} />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
                alignItems: "flex-end",
              }}
            >
              <SubmitButton
                // variants="outlined"
                type="button"
                onClick={() => updateFunction()}
                sx={{ maxWidth: "200px" }}
                title={step == 2 ? "Submit" : "Next" + ``}
              />
            </Box>
          </Paper>
        </>
      )}
    </>
  );
};

export default BeneficiaryAudioGramUI;
